<template>
  <div class="goodsContainer">
    <!-- 生成图片的html -->
    <div
      class="share_box"
      force-use-old-canvas="true"
      id="box-opicity"
      ref="imageWrapper"
    >
      <div>
        <!-- 生成图片的html -->
        <div>
          <div class="share-title">
            <div class="share-title-content">
              <img :src="avatarUrl" alt="" class="share-title-img" />
              <div class="share-title-span">
                <span>「{{ mallUserName }}」</span><span>的商品分享</span>
              </div>
            </div>
          </div>
          <!--  v-if="userAgent == true" -->
          <div class="share-concont">
            <img
              :src="goodsDetailPictureUrl"
              crossOrigin="anonymous"
              class="share-concont-img"
              ref="image"
            />
          </div>
          <div class="share-rewei">
            <div class="share-rewei-box">
              <div class="share-rewei-methos">
                <div id="share-shop-title">{{ goods.sellingPoint }}</div>
                <div class="share-rewei-methos-span share-rewei-methos-top">
                  ① 保存图片到相册
                </div>
                <div class="share-rewei-methos-span">② 打开微信扫码可见</div>
              </div>
              <div id="imgWrapper">
                <!-- <vue-qr :text="imageUrl"
                        :size="90"
                        :margin='0'
                        :correctLevel='1'
                        :callback="qrCodeCallback"
                        :logoScale="0.2"> </vue-qr> -->
                <img id="qrImg" :src="qsSrc" alt="" />
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div data-html2canvas-ignore id="qr">
      <vue-qr
        :text="imageUrl"
        :size="90"
        :margin="0"
        :correctLevel="1"
        :callback="qrCodeCallback"
        :logoScale="0.2"
      >
      </vue-qr>
    </div>
    <div class="goods" data-html2canvas-ignore>
      <div class="isShowLoading" v-if="isShowLoading">
        <van-loading color="#aab" vertical type="spinner" />
        <van-overlay :show="isShowLoading" />
      </div>
      <van-swipe class="goods-swipe" :autoplay="3000" indicator-color="#ff6274">
        <van-swipe-item v-for="thumb in goods.goodsPictures" :key="thumb.id">
          <div style="width: 100%; height: 100%">
            <img :src="thumb.pictureUrl" v-lazy="thumb.pictureUrl" />
          </div>
        </van-swipe-item>
      </van-swipe>
      <!-- <div class="goodsTime" v-if="limitGoods.limitQuantity !== undefined">
        活动时间：{{ limitGoods.beginTime.slice(0, 10) }}~{{ limitGoods.endTime.slice(0, 10) }}
      </div> -->
      <!-- <div class="whiteBackground">{{ limitDays }}</div>天
              <div class="whiteBackground">{{ limithours }}</div>时
              <div class="whiteBackground">{{ limitminutes }}</div>分
              <div class="whiteBackground">{{ limitseconds }}</div>秒结束 -->
      <div v-if="!limitGoods.isExpired&&limitGoods.limitQuantity !== undefined">
        <div class="limitTime">
          <img :src="image.value" alt="" />

          <div class="limitGoodsTime">
            <div>
              <div style="margin-bottom: 1px">
                始 {{ limitGoods.beginTime.slice(0, 10) }}
              </div>
              <div>止 {{ limitGoods.endTime.slice(0, 10) }}</div>
            </div>
            <div>
              <van-count-down :time="limitGoods.curTime" class="limitEndTime">
                <template v-slot="timeData">
                  <span class="whiteBackground">{{ timeData.days }}</span>
                  <span class="colon">天</span>
                  <span class="whiteBackground">{{ timeData.hours }}</span>
                  <span class="colon">时</span>
                  <span class="whiteBackground">{{ timeData.minutes }}</span>
                  <span class="colon">分</span>
                  <span class="whiteBackground">{{ timeData.seconds }}</span>
                  <span class="colon">秒结束</span>
                </template>
              </van-count-down>
            </div>
          </div>
        </div>
      </div>

      <van-cell :border="false">
        <!-- <div>
          <span class="goods-price">￥{{ formatPrice(goods.price) }}</span>
          <span class="line">￥{{ formatPrice(goods.originPrice) }}</span>
        </div> -->
        <!-- lhy 修改 -->
        <div class="flexBetween">
          <div style="float: left">
            <div>
              <span class="goods-price">￥{{ formatPrice(goods.price) }}</span>
              <span class="line">￥{{ formatPrice(goods.originPrice) }}</span>
            </div>
            <div class="goods-title">{{ goods.sellingPoint }}</div>
          </div>
          <!-- win 新增库存  -->
          <div class="flex-row">
            <div class="kc" v-if="isKCOpen">
              <div style="font-size: 12px">库存: {{ goods.stockCount }}</div>
            </div>

            <div
              style="float: right"
              v-if="
                (userInfo.userType == 'employee' &&
                  userInfo.statusName == 'agreed') ||
                userInfo.userType == 'owner'
              "
              @click="showPopup"
            >
              <div
                v-if="
                  avatarUrlFlag == true &&
                  goodsDetailPictureUrlFlag == true &&
                  qsSrcFlag == true
                "
              >
                <span
                  class="icon iconfont icon-fenxiangtubiao"
                  style="color: #ef0722; margin-left: 3px; font-size: 20px"
                ></span>
                <div style="color: #ef0722; font-weight: 500; font-size: 12px">
                  分享
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ======= -->
        <!-- <div class="goods-title">{{ goods.sellingPoint }}</div> -->
        <!-- 显示限购数量，已购数量，如活动结束，显示活动截止字样 -->
        <span v-if="!limitGoods.isExpired">
          <span
            style="font-size: 13px; color: #ee0a24"
            v-if="limitGoods.isExpired"
            >活动已截止</span
          >
          <span v-else>
            <span
              style="font-size: 13px; color: #ee0a24"
              v-if="limitGoods.userLimit >= limitGoods.limitQuantity"
              >限购件数已用完</span
            >
            <span
              style="font-size: 13px; color: #bcbcbc"
              v-if="limitGoods.userLimit < limitGoods.limitQuantity"
              >限购{{ limitGoods.limitQuantity }}件，已购{{
                limitGoods.userLimit
              }}件</span
            >
          </span>
        </span>
      </van-cell>
      <!-- <van-cell class="goods-express" :border="false" v-if="coupon">
        <van-col span="20">优惠券：该商品可使用{{ coupon.title }}</van-col>
      </van-cell>-->
      <!-- <van-cell class="goods-express">
         <div class="describe">规格: 请选择颜色分类/尺码规格 </div>
      </van-cell> -->
      <van-cell class="goods-express">
        <div class="flex-around">
          <div class="flex-center describe">
            <div class="cartTip"></div>
            7天无理由退换
          </div>
          <div class="flex-center describe">
            <div class="cartTip"></div>
            当天快速退款
          </div>
          <div class="flex-center describe">
            <div class="cartTip"></div>
            微信认证
          </div>
        </div>
      </van-cell>

      <!-- <van-cell-group class="goods-cell-group">
        <van-cell title="商品参数" is-link />
      </van-cell-group> 
      <van-divider :style="{ padding: '0 40px' }">宝贝详情</van-divider> -
      -->
      <div class="goodsDetail">商品参数</div>

      <div v-html="goods.detail"></div>
      <van-sku
        v-model="showSku"
        :sku="sku"
        :goods="goods"
        :goods-id="goods.id"
        :hide-stock="true"
        @stepper-change="stepperChange"
        :initial-sku="initialSku"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
        @sku-selected="onSkuSelected"
        :show-add-cart-btn="false"
        :stock-threshold="20"
        v-if="!limitGoods.isExpired"
        :quota="Number(limitGoods.limitQuantity)"
      >
        <!-- <template #sku-actions-top>优惠券：使用{{ selectedCoupon.name }}直降{{ selectedCoupon.price }}元</template> -->
        <!-- <template #sku-stepper>
          <div class="flexTween">
            <div class="name">购买数量</div>
            <div class="van-sku-stepper">
              <div class="number-item">
                <div class="selnum">
                  <div class="cut" @click="cutNumber">-</div>
                  <input class="number" type="number" @change="clickNumber(Number(getQuantity))" :value="getQuantity" />
                  <div class="add" @click="addNumber">+</div>
                </div>
              </div>
            </div>
          </div>
        </template> -->
        <!-- <template #sku-stepper> -->
        <div class="flexTween">
          <div class="name">购买数量</div>
          <div class="van-sku-stepper">
            <van-stepper
              v-model="getQuantity"
              :max="getLimitQuantity"
              @input="stepperChange(getQuantity)"
              integer
            />
          </div>
        </div>

        <!-- </template> -->

        <template #sku-actions="props">
          <div class="van-sku-actions">
            <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
            <van-button
              v-if="IsButton"
              square
              size="large"
              color="#ccc"
              disabled
              @click="props.skuEventBus.$emit('sku:buy')"
              >确定</van-button
            >
            <van-button
              v-else
              square
              size="large"
              type="danger"
              @click="props.skuEventBus.$emit('sku:buy')"
              >确定
            </van-button>
          </div>
        </template>
      </van-sku>
      <van-sku
        v-model="showSku"
        :sku="sku"
        :goods="goods"
        :goods-id="goods.id"
        :hide-stock="true"
        @stepper-change="stepperChange"
        :initial-sku="initialSku"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
        @sku-selected="onSkuSelected"
        :show-add-cart-btn="false"
        :stock-threshold="20"
        :quota="goods.goodsType == 2 ? 1 : 0"
        v-else
      >
        <!-- <template #sku-actions-top>优惠券：使用{{ selectedCoupon.name }}直降{{ selectedCoupon.price }}元</template> -->
        <template #sku-actions="props">
          <div class="van-sku-actions">
            <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
            <van-button
              v-if="IsButton"
              square
              size="large"
              color="#ccc"
              disabled
              @click="props.skuEventBus.$emit('sku:buy')"
              >确定</van-button
            >
            <van-button
              v-else
              square
              size="large"
              type="danger"
              :disabled="cartDisabled"
              @click="props.skuEventBus.$emit('sku:buy')"
              >确定
            </van-button>
          </div>
        </template>
      </van-sku>

      <!-- lhy 新增 sku弹窗 -->
      <van-sku
        v-model="showShareSku"
        :sku="sku"
        :goods="goods"
        :goods-id="goods.id"
        :hide-stock="true"
        @stepper-change="stepperChange"
        :initial-sku="initialSku"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
        @sku-selected="onSkuSelected"
        :show-add-cart-btn="false"
        :stock-threshold="20"
        :quota="Number(limitGoods.limitQuantity)"
      >
        <template #sku-actions="props">
          <div class="van-sku-actions">
            <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
            <van-button
              square
              size="large"
              type="danger"
              @click="props.skuEventBus.$emit('sku:buy')"
              >立即购买
            </van-button>
          </div>
        </template>
      </van-sku>
    </div>

    <van-goods-action
      style="
        z-index: 1;
        bottom: 0;
        left: 0;
        box-sizing: initial;
        width: 100%;
        position: fixed;
      "
    >
      <van-goods-action-icon icon="chat-o" @click="callPhone(phone)"
        >客服</van-goods-action-icon
      >

      <van-goods-action-icon
        :class="{ heartBeat: shake }"
        class="animated"
        icon="cart-o"
        :badge="cartQuantity"
        @click="onClickCart"
        style="background: transparent"
        >购物车</van-goods-action-icon
      >
      <div style="width: 100%; padding-right: 15px">
        <van-goods-action-button
          v-if="goods.goodsType !== 2"
          type="warning"
          @click="onAddCartClick"
          :disabled="isKCDisabled"
          color="#ee0a24"
          >加入购物车
        </van-goods-action-button>
        <van-goods-action-button
          v-if="goods.goodsType == 2"
          type="danger"
          @click="onBuyClick"
          >立即购买
        </van-goods-action-button>
      </div>
      <!-- lhy 分享是立即购买 参数方法不同 -->
      <!-- <div style="width: 100%; padding-right: 15px"
           v-if="shareTypeBtn">
        <van-goods-action-button type="danger"
                                 @click="shareBuyClick">立即购买
        </van-goods-action-button>
      </div> -->
      <!--  -->
    </van-goods-action>
    <!-- 客服电话弹窗 -->
    <van-dialog
      v-model="close"
      show-cancel-button
      @confirm="onConfirm"
      @cancel="onCancel"
    >
      <div class="phoneContent">
        <div style="padding-bottom: 8px">是否拨打4008658777?</div>
        <span style="font-size: 12px; color: #999"
          >工作时间：9:00-11:40 13:10-17:00</span
        >
      </div>
    </van-dialog>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <!-- lhy分享弹窗 -->
    <!-- <transition name="fade"
                appear> -->
    <div
      v-show="showShare"
      @touchmove.prevent
      @mousewheel.prevent
      class="pop_share"
    >
      <div class="pop_position">
        <div class="pop_share_box">
          <!--   v-show="!showPicture" -->
          <img id="imgId" alt="" />
        </div>
        <div class="pop_share_save">
          <img src="../../../assets/images/hand.png" />
          <span>长按图片可转发/保存呦~</span>
        </div>
        <div style="margin: 16px 0; text-align: center">
          <van-icon name="close" size="40" color="#fff" @click="closePop()" />
        </div>
      </div>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
import {
  Tag,
  Col,
  Icon,
  Cell,
  CellGroup,
  Swipe,
  Toast,
  SwipeItem,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  Dialog,
  Divider,
  Loading,
  Overlay,
  Button,
  Stepper,
  Popup,
  CountDown,
} from "vant";
import { mapGetters, mapActions } from "vuex";
import html2canvas from "html2canvas";
import domtoimage from "dom-to-image";
import QRCode from "qrcodejs2";
import service from "../../api/goods/index";
import serviceCart from "../../api/cart/index";
import loading from "../../components/loading/loading";
import vueQr from "vue-qr";
export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Toast.name]: Toast,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Sku.name]: Sku,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [Divider.name]: Divider,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Button.name]: Button,
    [Stepper.name]: Stepper,
    [CountDown.name]: CountDown,
    [Popup.name]: Popup,
    loading,
    vueQr,
  },
  computed: {
    ...mapGetters(["userInfo", "cartInfo"]),
    cartQuantity() {
      return this.cartInfo == null ? "" : this.cartInfo;
    },
  },
  data() {
    return {
      isKCOpen: false, //库存是否开启，
      isKCDisabled: false, //如果开启显示库存，库存为0时加入购物车按钮禁用，其他情况按钮均可用
      cartDisabled: false, //购物车是否禁用
      url: "",
      dataUrl: "",
      // lhy 修改 新增\
      qsSrc: "",
      encodeUrl: "", //获取的地址
      qrCode: "", //二维码链接
      screenshotImage: "", // 保存的base64地址
      showShare: false, //分享弹窗
      goodsDetailPictureUrl: "", //分享详情图片
      imgUrl: "",
      showPicture: true, //图片显示
      shareTypeBtn: false, // 是不是分享状态进入
      showShareSku: false, //分享状态下立即购买弹窗
      avatarUrl: "", //截图头像
      mallUserName: "", //截图用户名
      goodsDetailPictureUrlFlag: false,
      avatarUrlFlag: false,
      qsSrcFlag: false,
      src: "",
      // =========
      close: false, //关闭弹窗
      getQuantity: 1,
      getLimitQuantity: 100,
      isLoading: true, //loading状态
      goods: {},
      showSku: false,
      // sku: {},
      sku: {},
      initialSku: {},
      shake: false,
      // coupon: {},
      // selectedCoupon: {},
      quantity: 1,
      CskuId: 0,
      CskuDiscountPrice: 0,
      clickType: 0,
      minQuantity: 0,
      maxQuantity: 0,
      availableTimes: 0,
      canBuy: false,
      errCode: 0,
      isShowLoading: false,
      IsButton: false,
      phone: 4008658777,

      limitGoods: {
        limitQuantity: "",
        userLimit: "",
        isExpired: true,
        beginTime: "2022-06-01T00:15:00", //限购开始日期
        endTime: "2022-09-01T00:15:00", //限购结束日期
        curTime: 0, //限购毫秒
      },
      cartList: [],
      limitCartList: {}, //当前商品限购在购物车的数据
      limitDays: "",
      limithours: "",
      limitminutes: "",
      limitseconds: "",
      image: {
        type: String,
        value:
          "data:image/jpeg;base64,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",
      },
      // showCartSku: false
      element: "",
      userAgent: null,
      imageUrl: "",
      qrCodeUrl: "",
    };
  },

  methods: {
    ...mapActions(["updateUserCartQuantity"]),
    //=====lhy 修改======
    // ==============================================
    qrCodeCallback(url) {
      let callbackUrl = url.replace(/^data:image\/\w+;base64,/, "");
      new Promise((resolve) => {
        this.qsSrc = "data:image/jpg;base64," + callbackUrl;
        resolve(this.qsSrc);
      }).then((res) => {
        if (res != "" && res != null && res != undefined) {
          this.qsSrcFlag = true;
        }
      });
    },
    // 分享生成图片
    showPopup() {
      this.addPicture();
    },
    closePop() {
      this.showShare = false;
    },
    // 图片base64转blob数据流
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(","); //分割为数组，分割到第一个逗号
      let mime = arr[0].match(/:(.*?);/)[1]; //获取分割后的base64前缀中的类型
      let bstr = window.atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime }); //文件类型格式
    },
    // 获取分享图片
    getshare() {
      this.goodsDetailPictureUrlFlag = false;
      service.getsharePicture(this.$route.query.code).then((res) => {
        if (res.statusCode == 200) {
          new Promise((resolve) => {
            const src = URL.createObjectURL(
              this.dataURLtoBlob("data:image/jpg;base64," + res.data)
            );
            this.goodsDetailPictureUrl = src;
            resolve(this.goodsDetailPictureUrl);
          }).then((res) => {
            if (res != "" && res != null && res != undefined) {
              this.goodsDetailPictureUrlFlag = true;
            }
          });
          // const src = URL.createObjectURL(this.dataURLtoBlob("data:image/jpg;base64," + res.data))
          // this.goodsDetailPictureUrl = src;
          // this.goodsDetailPictureUrl = "data:image/jpg;base64," + res.data;
        }
      });
    },
    // 获取base64头像
    getAvarShare() {
      this.avatarUrlFlag = false;
      service.getUserImg(this.userInfo.userId).then((res) => {
        if (res.statusCode == 200) {
          new Promise((resolve) => {
            const src = URL.createObjectURL(
              this.dataURLtoBlob("data:image/jpg;base64," + res.data)
            );
            this.avatarUrl = src;
            resolve(this.avatarUrl);
          }).then((res) => {
            if (res != "" && res != null && res != undefined) {
              this.avatarUrlFlag = true;
            }
          });

          // this.avatarUrl = "data:image/jpg;base64," + res.data;
        }
      });
    },

    // 生成图片的
    addPicture() {
      this.isLoading = true;
      // 解决滚动截图不全的问题
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const opts = {
        useCORS: true, //  第三个修改的地方
        allowTaint: true, //允许跨域（默认false）
        scale: 2, // 处理模糊问题
        scrollY: 0,
        scrollX: 0,
      };
      let htmlCanvas = window.html2canvas || html2canvas;
      window.html2canvas = htmlCanvas;
      htmlCanvas(document.getElementById("box-opicity"), opts).then(
        (canvas) => {
          // new Promise((resolve) => {
          //   setTimeout(() => {
          this.src = canvas.toDataURL("image/jpg");
          //     resolve(this.src)
          //   }, 0)

          // }).then((src) => {
          document.getElementById("imgId").setAttribute("src", this.src);
          this.showPicture = false;
          this.showShare = true;
          this.isLoading = false;
        }
      );
    },
    // lhy 新增
    getUrl() {
      console.log(this.userInfo, "存储信息的地方");
      console.log(webconfig.appid);
      this.encodeUrl = "https://" + window.location.host + "/login";
      var redirect_uri = encodeURIComponent(this.encodeUrl);
      // this.qrCode = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=https%3A%2F%2Ftestygw.m.taohuasanbao.com%2Fredirect&response_type=code&scope=snsapi_userinfo&state=login?goodsId=${this.$route.query.code}?shareUserId=${this.userInfo.userId}?SharedType=1&isShared=true#wechat_redirect`
      // this.qrCode = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=login?goodsId=${this.$route.query.code}?shareUserId=${this.userInfo.userId}?SharedType=1?isShared=true#wechat_redirect`
      // 跳转商城登录页面
      // this.qrCode = `${this.encodeUrl}?goodsId=${this.$route.query.code}&shareUserId=${this.userInfo.userId}&SharedType=1&isShared=true`;
      this.imageUrl = `${this.encodeUrl}?goodsId=${this.$route.query.code}&shareUserId=${this.userInfo.userId}&SharedType=1&isShared=true`;
    },

    formatPrice(price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    callPhone(phoneNumber) {
      // Dialog.confirm({
      //   message: "是否拨打4008658777?",
      // })
      //   .then(() => {
      //     window.location.href = "tel://" + phoneNumber;
      //   })
      //   .catch(() => { });
      this.close = true;
    },
    // 确定
    onConfirm() {
      window.location.href = "tel://" + this.phone;
    },
    // 取消
    onCancel() {
      this.close = false;
    },
    onBuyClick() {
      this.clickType = 0;
      this.showSku = !this.showSku;
      // if (
      //   this.userInfo.isEmployee &&
      //   this.userInfo.employee.statusName !== "agreed"
      // ) {
      //   Dialog.alert({
      //     title: "提示",
      //     message: "您的账号异常,暂时不能购买商品"
      //   });
      // } else {
      //   this.showSku = !this.showSku;
      //   // this.showCartSku = true;
      // }
    },
    // lhy 分享立即购买按钮
    shareBuyClick() {
      this.clickType = 3;
      this.showShareSku = true;
    },
    onAddCartClick() {
      console.log("cart");
      this.clickType = 1;
      this.showSku = !this.showSku;
    },
    toShowSku() {
      let userInfo = this.userInfo;
      if (!userInfo || !userInfo.token || !userInfo.isLogin) {
        Dialog.alert({
          message: "请先登录账号",
        }).then(() => {
          this.$router.replace({
            path: "/login",
            query: { redirect: this.$router.currentRoute.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        });
      }
      // if (
      //   !userInfo.isEmployee &&
      //   !userInfo.isOwner &&
      //   userInfo.statusName === "limited"
      // ) {
      //   Dialog.alert({
      //     title: "提示",
      //     message: "请绑定手机号码和分享编码"
      //   }).then(() => {
      //     this.$router.push("setting");
      //   });
      // }
    },
    onClickCart() {
      this.$router.push("cart");
      // this.cart_info = ++this.cart_info;
      //this.show = !this.show;
    },
    stepperChange(value) {
      console.log(value, "this.quantity");
      var limitGoodsNum =
        this.limitGoods.limitQuantity - this.limitGoods.userLimit;
      if (!this.limitGoods.isExpired) {
        if (value > limitGoodsNum) {
          value = limitGoodsNum;
          this.getQuantity = limitGoodsNum;
          Toast(`限购商品仅剩${limitGoodsNum}件`);
        }
      }
      // clearTimeout(timer);
      if (value > 100) {
        value = 100;
        Toast("单件商品每次最多可添加100件");
      }
      console.log(this.getQuantity, value, "this.getQuantity");
      this.getQuantity = value;

      // if (this.isCoupons == true) {
      //   if (this.CskuId !== 0) {
      //     this.selectedCoupon.discountPrice =
      //       (this.skuSelected.price / 100) * (this.quantity - 1) +
      //       this.CskuDiscountPrice;
      //   } else {
      //     this.selectedCoupon.discountPrice =
      //       (this.skuSelected.price / 100) * this.quantity;
      //   }
      // }
    },
    onSkuSelected({ skuValue, selectedSku, selectedSkuComb }) {
      this.IsButton = false;
      for (var i in selectedSku) {
        if (selectedSku[i] == "") {
          this.IsButton = true;
        }
      }
      this.skuSelected = selectedSkuComb;
      this.goods.picture = selectedSkuComb.imgUrl;
      // console.log(selectedSkuComb);
    },
    // sorry() {
    //   this.shake = true;
    //   setTimeout(() => {
    //     this.shake = false;
    //   }, 500);
    // },
    // 获取限购商品详情
    GetLimitGoods(id) {
      service.GetLimitGoodsDetail([id]).then((res) => {
        let limitGoods = {};
        if (res.statusCode == 200 && res.data.length > 0) {
          limitGoods = res.data[0];
          // if (limitGoods.isExpired) {
          //   // Toast("活动已截止");
          //   return
          // }
          console.log(limitGoods,855)
          this.limitGoods = res.data[0];
          // this.diffTime(this.limitGoods.beginTime, this.limitGoods.endTime)
          var nowTime = Date.parse(
            new Date(this.limitGoods.nowTime.replace(/-/g, "/"))
          ); //服务器当前时间
          var endTime = Date.parse(
            new Date(this.limitGoods.endTime.replace(/-/g, "/"))
          ); //结束时间
          this.limitGoods.curTime = endTime - nowTime; //剩余时间
          // console.log(this.limitGoods.curTime,nowTime,endTime,endTime - nowTime,867)
          
        } else {
          this.limitGoods = {};
        }
      });
    },
    clickNumber(quantity) {
      console.log(quantity, 375);
    },
    addNumber: function () {
      if (this.maxQuantity != 0 && this.maxQuantity <= this.quantity) {
        Toast("最多购买" + this.maxQuantity + "件");
        return;
      }
      this.quantity = this.quantity + 1;
    },
    cutNumber: function () {
      if (this.minQuantity >= this.quantity) {
        Toast("最少购买" + this.minQuantity + "件");
        return;
      }
      this.setData({
        quantity: this.quantity - 1 > 1 ? this.quantity - 1 : 1,
      });
    },
    init(code) {
      this.isShowLoading = true;
      service
        .get(code)
        .then((response) => {
          this.isLoading = false;
          this.isShowLoading = false;
          // 如果返回数据为null 提示该商品已下架并返回上一页
          if (response.data == null) {
            Toast("该商品已下架");
            this.$router.go(-1);
            return;
          }
          this.goods = response.data;
          console.log("121212");
          //lhy 新增分享图片详情

          // this.imgToBase64(this.goodsDetailPictureUrl)
          // console.log(this.goodsDetailPictureUrl, '111111');
          // =======================
          // this.getParams.retailPrice = response.data.originPrice
          this.sku = {};
          let tSku = {};
          let tList = [];
          let tTree = [];

          this.goods.goodsSkus.map((item) => {
            let s = ["0", "0", "0"];
            let ts = item.specificationCodes.split(",");
            s[0] = ts[0] ? ts[0] : "0";
            s[1] = ts[1] ? ts[1] : "0";
            s[2] = ts[2] ? ts[2] : "0";
            tList.push({
              goodsId: this.goods.id, // goodsId，下单时后端需要
              skuCodes: item.skuCodes, // skuCodes，下单时后端需要
              skuNo: item.skuNo, // skuNo，下单时后端需要
              price: item.retailPrice * 100, // 价格（单位分）
              retailPrice: item.retailPrice,
              s1: s[0], // 规格类目 k_s 为 s1 的对应规格值 id
              s2: s[1], // 规格类目 k_s 为 s2 的对应规格值 id
              s3: s[2], // 最多包含3个规格值，为0表示不存在该规格
              id: item.id,
              imgUrl: item.pictureUrl,
              specificationNames: item.specificationNames,
              stock_num: item.stock, // 当前 sku 组合对应的库存
            });
            // 单规格
            // let t_pictureUrl = item.pictureUrl;

            // details.push({
            //   id: item.specificationCodes, // skuValueId：规格值 id
            //   name: item.specificationNames, // skuValueName：规格值名称
            //   imgUrl: t_pictureUrl, // 规格类目图片，只有第一个规格类目可以定义图片
            //   previewImgUrl: t_pictureUrl // 用于预览显示的规格类目图片
            // });
            // tTree.push({
            //   k: "规格", // skuKeyName：规格类目名称
            //   v: details,
            //   tock_num: item.stock,
            //   k_s: "s" + 1 // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            // });
          });
          // 多规格
          this.goods.goodsSpecifications.map((item, i) => {
            let details = [];
            item.goodsSpecificationDetails.map((detail) => {
              let t_sku = this.goods.goodsSkus;
              let t_pictureUrl = "";
              t_sku.map((d) => {
                // console.log(d, detail.code, 353);
                if (d.specificationCodes.indexOf(detail.id) >= 0) {
                  t_pictureUrl = d.pictureUrl;
                }
              });
              details.push({
                id: detail.id, // skuValueId：规格值 id
                name: detail.name, // skuValueName：规格值名称
                imgUrl: t_pictureUrl, // 规格类目图片，只有第一个规格类目可以定义图片
                previewImgUrl: t_pictureUrl, // 用于预览显示的规格类目图片
                stock_num: 123,
              });
            });

            tTree.push({
              k: item.name, // skuKeyName：规格类目名称
              v: details,
              tock_num: item.stock_num,
              k_s: "s" + (i + 1), // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            });
          });

          tSku = {
            list: tList,
            tree: tTree,
            price: 0, //缺总库存
          };
          this.sku = tSku;
          this.initialSku = {
            // 键：skuKeyStr（sku 组合列表中当前类目对应的 key 值）
            // 值：skuValueId（规格值 id）
            s1: tList[0].s1,
            s2: tList[0].s2,
            // 初始选中数量
            selectedNum: 1,
            // 初始选中的商品属性
            // 键：属性id
            // 值：属性值id列表
            selectedProp: {},
          };
          // 库存是否开启
          this.isKCOpen = response.data.isStockGoods;
          this.isKCDisabled = false;
          // 当「库存状态」为「开启」且库存=0 时，「加入购物车」按钮禁用不可点击
          if (this.isKCOpen && response.data.stockCount <= 0) {
            this.isKCDisabled = true;
          }

          // service.getGoodsCoupon(code).then(res => {
          //   this.coupon = res.data;
          // });
        })
        .catch((err) => {
          this.isShowLoading = false;
          Toast.fail("加载失败");
        });
    },

    onBuyClicked(data) {
      this.isLoading = true;
      var getParams = {};

      this.sku.list.map((v) => {
        if (
          v.s1 == data.selectedSkuComb.s1 &&
          v.s2 == data.selectedSkuComb.s2 &&
          v.s3 == data.selectedSkuComb.s3
        ) {
          console.log(this.sku, data);
          getParams = {
            goodsId: data.selectedSkuComb.goodsId,
            goodsName: this.goods.name,
            quantity: Number(data.selectedNum),
            pictureUrl: data.selectedSkuComb.imgUrl,
            // retailPrice: data.selectedSkuComb.price / 100,
            retailPrice: data.selectedSkuComb.retailPrice,
            specificationNames: data.selectedSkuComb.specificationNames,
            skuId: data.selectedSkuComb.id,
            skuCode: data.selectedSkuComb.skuCodes,
            skuNo: data.selectedSkuComb.skuNo,
          };
          getParams.type = 1;
        }
      });
      // 原有立即购买
      if (this.clickType == 0) {
        if (!this.userInfo.phoneNumber) {
          Dialog.alert({
            title: "提示",
            message: "只有绑定手机号码才能购买哦",
          }).then(() => {
            this.$router.push("setting");
          });
          return;
        }
        this.$router.push({
          name: "checkout",
          query: {
            goodsId: getParams.goodsId,
            quantity: getParams.quantity,
            skuId: getParams.skuId,
            skuCode: getParams.skuCodes,
            skuNo: getParams.skuNo,
            // couponCode: this.coupon.couponCode,
            type: 0,
          },
        });
      }
      // lhy 新增立即购买  clickType为3 代表立即购买
      if (this.clickType == 3) {
        if (!this.userInfo.phoneNumber) {
          Dialog.alert({
            title: "提示",
            message: "只有绑定手机号码才能购买哦",
          }).then(() => {
            this.$router.push("setting");
          });
          return;
        }
        this.$router.push({
          name: "checkout",
          query: {
            goodsId: getParams.goodsId,
            quantity: getParams.quantity,
            skuId: getParams.skuId,
            type: 3,
          },
        });
      }
      // 添加购物车
      if (this.clickType == 1) {
        this.cartDisabled = true;
     
        // 是限购
        if (this.limitGoods.isExpired == false) {
          console.log('是限购')
          // if (this.limitGoods.isExpired == true) {
          //   Toast("活动已截止");
          //   return;
          // }
          service
            .getCart()
            .then((res) => {
              if (res.statusCode == 200) {
                var limitNum =
                  this.limitGoods.limitQuantity - this.limitGoods.userLimit;
                if (res.data.length > 0) {
                  // 剩余限购数量
                  for (var i = 0; i < res.data.length; i++) {
                    if (res.data[i].goodsId == this.limitGoods.goodsId) {
                      this.limitCartList = res.data[i];
                    }
                  }
                  console.log(
                    this.limitCartList,
                    limitNum,
                    "this.limitCartList"
                  );
                }
                // limitCartList购物车测里面限购商品大于0，
                if (this.limitCartList.quantity !== undefined) {
                  // 剩余限购数量大于购物限购数量
                  if (limitNum > this.limitCartList.quantity) {
                    // 剩余限购数量减购物车限购数量小于添加的数量
                    if (
                      limitNum - this.limitCartList.quantity >
                      getParams.quantity
                    ) {
                      service
                        .addBasket(getParams)
                        .then((res) => {
                          setTimeout(() => {
                            this.isLoading = false;
                          }, 500);
                          if (res.statusCode == 200) {
                            this.updateUserCartQuantity(res.data);
                            this.showSku = false;
                            this.shake = true;
                            setTimeout(() => {
                              this.shake = false;
                            }, 1500);
                          }
                        })
                        .catch((err) => {
                          this.isLoading = false;
                          // Toast(err);
                        });
                    } else {
                      data.selectedNum = limitNum - this.limitCartList.quantity;
                      getParams.quantity =
                        limitNum - this.limitCartList.quantity;
                      if (getParams.quantity > 0) {
                        service
                          .addBasket(getParams)
                          .then((res) => {
                            setTimeout(() => {
                              this.isLoading = false;
                            }, 500);
                            if (res.statusCode == 200) {
                              this.updateUserCartQuantity(res.data);
                              // this.isLoading = false;
                              Toast("可添加购物车次数已达上限");
                              this.showSku = false;
                              this.shake = true;
                              setTimeout(() => {
                                this.shake = false;
                              }, 1500);
                            }
                          })
                          .catch((err) => {
                            this.isLoading = false;
                            // Toast(err);
                          });
                      } else {
                        Toast("该商品不能添加");
                      }
                    }
                  } else {
                    setTimeout(() => {
                      this.isLoading = false;
                    }, 500);
                    this.showSku = false;
                    Toast("该商品不能继续添加");
                    return;
                  }
                } else {
                  // 购物车里面没有限购商品 剩余数量大于加入的数量
                  if (limitNum > getParams.quantity) {
                    service
                      .addBasket(getParams)
                      .then((res) => {
                        setTimeout(() => {
                          this.isLoading = false;
                        }, 500);
                        if (res.statusCode == 200) {
                          this.updateUserCartQuantity(res.data);
                          this.showSku = false;
                          this.shake = true;
                          setTimeout(() => {
                            this.shake = false;
                          }, 1500);
                        }
                      })
                      .catch((err) => {
                        this.isLoading = false;
                        // Toast(err);
                      });
                  } else {
                    data.selectedNum = limitNum;
                    getParams.quantity = limitNum;
                    // 要加入的数量大于0可以添加
                    if (getParams.quantity > 0) {
                      service
                        .addBasket(getParams)
                        .then((res) => {
                          setTimeout(() => {
                            this.isLoading = false;
                          }, 500);
                          if (res.statusCode == 200) {
                            this.updateUserCartQuantity(res.data);
                            // this.isLoading = false;
                            Toast("可添加购物车次数已达上限");
                            this.showSku = false;
                            this.shake = true;
                            setTimeout(() => {
                              this.shake = false;
                            }, 1500);
                          }
                        })
                        .catch((err) => {
                          this.isLoading = false;
                          // Toast(err);
                        });
                    } else {
                      Toast("您的添加次数已达上限");
                      this.showSku = false;
                      setTimeout(() => {
                        this.isLoading = false;
                      }, 500);
                    }
                  }
                }
              }
            })
            .catch((err) => {
              // Toast(err);
            });
        }
          else{
          // if (this.limitGoods.isExpired == true) {
          //   Toast("活动已截止");
          //   return;
          // }
          console.log('机那里')
          if (data.selectedNum > 100) {
            Toast("单次只能添加100件");
          }
          service
            .addBasket(getParams)
            .then((res) => {
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
              if (res.statusCode == 200) {
                this.updateUserCartQuantity(res.data);
                // this.isLoading = false;
                this.showSku = false;
                this.shake = true;
                setTimeout(() => {
                  this.shake = false;
                }, 1500);
              }
            })
            .catch((err) => {
              // Toast(err);
            })
            .finally(() => {
              setTimeout(() => {
                this.cartDisabled = false;
                this.isLoading = false;
              }, 500);
            });
        }
      }
    },
    onAddCartClicked(data) {
      this.isShowLoading = true;
      this.showSku = true;
      let getParams = {};
      this.sku.list.map((v) => {
        if (
          v.s1 == data.selectedSkuComb.s1 &&
          v.s2 == data.selectedSkuComb.s2 &&
          v.s3 == data.selectedSkuComb.s3
        ) {
          getParams.skuId = v.id;
          getParams.quantity = data.selectedNum;
        }
      });
      this.loading = true;
      // service.addBasket(getParams).then((r) => {
      //   this.isShowLoading = false;
      //   this.showSku = false;
      //   this.shake = true;
      //   setTimeout(() => {
      //     this.shake = false;
      //   }, 1500);
      //   this.updateUserCartQuantity(r.data);
      //   Toast.clear();
      // });
    },
    // lhy 二维码生成
    // creatQrCode () {
    //   let qrcode = new QRCode("qrcode", {
    //     width: 90, // 设置宽度，单位像素
    //     height: 90, // 设置高度，单位像素
    //     typeNumber: 4, // 二维码图案对齐模式位置表
    //     text: this.qrCode, // 设置二维码内容或跳转地址
    //     correctLevel: QRCode.CorrectLevel.L,
    //   });
    // },
  },
  // lhy 阻止遮罩层滚动
  mousewheel(e) {
    e.preventDefault();
  },

  mounted() {
    // 用户名过长 截取拼接...
    this.mallUserName = `${this.userInfo.nickName}`;
    if (this.mallUserName.length > 5) {
      this.mallUserName = this.mallUserName.slice(0, 5);
      this.mallUserName = `${this.mallUserName}...`;
    }
    if (this.$route.query.type === "1") {
      this.shareTypeBtn = true;
    } else {
      this.shareTypeBtn = false;
    }
    localStorage.removeItem("backHis");
    this.init(this.$route.query.code);
    this.GetLimitGoods(this.$route.query.code);
    this.toShowSku();
    // lhy 新增方法

    if (
      (this.userInfo.userType == "employee" &&
        this.userInfo.statusName == "agreed") ||
      this.userInfo.userType == "owner"
    ) {
      this.getshare();
      this.getAvarShare();
      this.getUrl();
    }

    // this.imgToBase64(this.userInfo.avatarUrl);

    // let file = this.base64ImgtoFile(this.avatarUrl);
    // this.avatarUrl = window.webkitURL.createObjectURL(file) || window.URL.createObjectURL(file);
    // console.log(this.imgToBase64(this.userInfo.avatarUrl), 'imgToBase64');

    // 如果是 分享过来的 根据标识 加入购物车更改为立即购买

    // serviceCart.getCartNumber().then((res) => {
    //   this.updateUserCartQuantity(res.data);
    // });
  },
};
</script>

<style lang="less">
// 分享弹窗

.pop_share {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: grid;
  place-items: center;
  .pop_position {
    position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .pop_share_box {
    // margin: 0 auto;
    // margin-top: 20%;
    width: 295px;
    // height: 439px;
    // background: #ffffff;
    // border-radius: 8px;
  }
  .pop_share_save {
    text-align: center;
    margin: 0 auto;
    font-size: 12px;
    width: 100%;
    font-weight: 400;
    color: #ffffff;
    line-height: 12px;
    margin-top: 16px;
    img {
      display: inline-block;
      vertical-align: middle;
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
// ==lhy 修改======
//lhy新增邀请会员动画
#share_nickname {
  display: inline-block;
  vertical-align: middle;
  min-width: 40px;
  // max-width: 100px;
  // overflow: hidden;
  // white-space: nowrap;
  // -o-text-overflow: ellipsis;
  // text-overflow: ellipsis;
}
#share_text {
  // display: inline-block;
  vertical-align: middle;
}
#box-opicity {
  position: absolute;
  z-index: -1;
}
.fade {
  &-enter {
    &-from {
      opacity: 0;
    }
    &-to {
      opacity: 1;
    }
    &-active {
      transition: opacity 0.6s;
    }
  }
  &-leave {
    opacity: 1;
    &-to {
      opacity: 0;
    }
    &-active {
      transition: opacity 0.6s;
    }
  }
}
// 分享弹窗修改
#share-shop-title {
  height: auto;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  text-align: left;
  margin-bottom: 14px;
}
.share_box {
  width: 295px;
  height: 469px;
  overflow: hidden;
  .share-title {
    box-sizing: border-box;
    height: 64px;
    width: 100%;
    // background: #fff;
    border-bottom: 1px dashed #e6e6e6;
    &-content {
      padding: 16px 0 16px 10px;
      height: 32px;
      width: 100%;
      text-align: left;
    }
    &-img {
      width: 32px;
      height: 32px;
      background: 50%;
      margin-right: 10px;
      display: inline-block;
      vertical-align: middle;
      border-radius: 50%;
    }
    &-span {
      width: 200px;
      display: inline-block;
      vertical-align: middle;
      color: #666666;
      line-height: 18px;
    }
  }
  .share-concont {
    box-sizing: border-box;
    height: 263px;
    width: 284px;
    margin: 15px 0 0 16px;
    overflow: hidden;
    // border-bottom: 1px dashed #e6e6e6;
    // &-box {
    //   padding: 15px 16px 0 16px;
    // }
    &-img {
      width: 263px;
      height: 263px;
      border-radius: 4px;
    }
    &-span {
      width: auto;
      height: 14px;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      line-height: 14px;
    }
  }
  .share-conconts {
    box-sizing: border-box;
    height: 263px;
    width: 284px;
    margin: 15px 0 0 15px;
    overflow: hidden;
    // border-bottom: 1px dashed #e6e6e6;
    // &-box {
    //   padding: 15px 16px 0 16px;
    // }
    &-img {
      width: 263px;
      height: 263px;
      border-radius: 4px;
    }
    &-span {
      width: auto;
      height: 14px;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      line-height: 14px;
    }
  }
  .share-rewei {
    height: 110px;
    overflow: hidden;
    &-box {
      margin: 15px 18px 0 15px;
      height: 110px;
    }
    &-boxs {
      margin: 15px 20px 0 10px;
      height: 110px;
    }
    // &-boxs {
    //   margin: 15px 20px 0 13px;
    //   height: 110px;
    // }
    &-methos {
      float: left;
      height: 110px;
      width: calc(100% - 100px);
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 12px;
      float: left;
      &span {
        width: auto;
      }
      &-top {
        margin-bottom: 12px;
      }
    }
    &-img {
      float: right;
      width: 48px;
      height: 48px;
    }
    &-imgs {
      width: 48px;
      height: 48px;
    }
  }
}
.goodsContainer {
  width: 100%;
  // height: calc(100% - 13.4vw);
  min-height: 100vh;
  overflow-x: hidden;
  font-family: Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB",
    "Heiti SC", STXihei, "Microsoft YaHei", SimHei;
  font-size: 14px;
  // 库存
  .kc {
    padding: 0 16px;
    color: rgba(146, 146, 146, 1);
  }
  #qr {
    width: 90px;
    height: 90px;
    display: none;
  }
  #imgWrapper {
    float: right;
    width: 90px;
    height: 90px;
    margin-top: 5px;
  }
  .limitTime {
    height: 40px;
    position: relative;
  }

  .whiteBackground {
    width: 24px;
    height: 24px;
    background: #ffffff;
    border-radius: 12px;
    color: #ef0722;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
    margin-left: 4px;
  }

  .limitEndTime {
    margin-left: 8px;
    display: flex;
    align-items: center;
    font-size: 10px;
    color: #fff;
  }

  .limitGoodsTime {
    height: 40px;
    position: absolute;
    top: 0px;
    left: 98px;
    color: #fff;
    font-size: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
  }

  // padding-bottom: 13.4vw;
  .van-goods-action {
    height: 16vw;
  }

  .van-sku-row__item-img {
    .van-image__error,
    .van-image__img,
    .van-image__loading {
      width: 6.4vw;
    }
  }

  .van-sku-row__item-name {
    font-size: 12px;
  }

  // hidden stock
  .van-sku-header__goods-info {
    padding: 5.2vw 5.33333vw 7vw 0;

    .van-sku__goods-price {
      height: 9vw;
    }
  }

  .goodsDetail {
    height: 50px;
    width: 100%;
    background: #fff;
    font-size: 15px;
    text-indent: 15px;
    line-height: 50px;
    color: #000;
    font-weight: 400;
  }

  .van-sku-stepper {
    justify-content: flex-end;
    display: flex;
    // padding-right: 10px;
    // padding-top: 12px;
  }

  .selnum {
    display: flex;
    border: 1px solid;

    .number {
      width: 26px;
      text-align: center;
      border-left: 1px solid;
      border-right: 1px solid;
    }

    .cut {
      width: 5vw;
      text-align: center;
    }

    .add {
      width: 5vw;
      text-align: center;
    }
  }

  .number-item {
    display: flex;
    justify-content: flex-end;
  }
}

.line {
  text-decoration: line-through;
  margin-left: 2vw;
  font-size: 3.2vw;
}

.goods {
  // background: #f7f7f7;
  overflow-x: hidden;
  overflow: auto;
  padding-bottom: 15vw;

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 4vw;
    color: #000;
  }

  &-price {
    color: #ee0a24;
    font-size: 5.3vw;
    letter-spacing: 1px;
  }

  &-express {
    font-size: 3.2vw;
    padding: 2.3vw 0;
    margin: 2vw 0;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}

// .bounce-enter-active {
//   animation: bounce-in 0.5s;
// }
// .bounce-leave-active {
//   animation: bounce-in 0.5s reverse;
// }
// @keyframes bounce-in {
//   0% {
//     transform: scale(0);
//   }
//   50% {
//     transform: scale(1.5);
//   }
//   100% {
//     transform: scale(1);
//   }
// }
</style>
